import axios from 'axios';

import { SELF_MATCH_DUTIES } from 'RestAPIs/endpoints';

export const handleSelfMatchRequest = (
  requestId: number,
  type: 'subscribe' | 'reject'
) =>
  axios.put(
    SELF_MATCH_DUTIES,
    {},
    {
      pathParams: { requestId, type }
    }
  );
